import { createSagaAction } from '../../shared/sagas'
import { createReducer } from '../../shared/reducers'

// Constants
export const constants = {
  GET_COMPANY_ADDRESSES: createSagaAction('GET_COMPANY_ADDRESSES'),
  COMPANY_CREATE_ADDRESS: createSagaAction('COMPANY_CREATE_ADDRESS'),
  COMPANY_UPDATE_ADDRESS: createSagaAction('COMPANY_UPDATE_ADDRESS'),
  COMPANY_DELETE_ADDRESS: createSagaAction('COMPANY_DELETE_ADDRESS'),
  UPDATE_COMPANY_PRIMARY_ADDRESS: createSagaAction('UPDATE_COMPANY_PRIMARY_ADDRESS')
}

// Action Creators
export const actions = {
  getCompanyAddresses: ({ companyId }) => ({
    type: constants.GET_COMPANY_ADDRESSES.ACTION,
    companyId
  }),
  companyCreateAddress: ({ address, companyId, userId }) => ({
    type: constants.COMPANY_CREATE_ADDRESS.ACTION,
    address,
    companyId,
    userId
  }),
  companyUpdateAddress: ({ addressId, address, companyId, userId }) => ({
    type: constants.COMPANY_UPDATE_ADDRESS.ACTION,
    addressId,
    address,
    companyId,
    userId
  }),
  deleteCompanyAddresses: ({ addressId, companyId }) => ({
    type: constants.COMPANY_DELETE_ADDRESS.ACTION,
    companyId,
    addressId
  }),
  updateCompanyPrimaryAddress: ({ companyId, addressId }) => ({
    type: constants.UPDATE_COMPANY_PRIMARY_ADDRESS.ACTION,
    companyId,
    addressId
  })
}

// Reducer
const initialState = {}

export default createReducer(initialState, (state, { type, payload }) => {
  switch (type) {
    default:
      return state
    case constants.GET_COMPANY_ADDRESSES.SUCCESS:
      return { ...state, payload }
    case constants.COMPANY_CREATE_ADDRESS.SUCCESS:
      return { ...state }
    case constants.COMPANY_UPDATE_ADDRESS.SUCCESS:
      return { ...state }
    case constants.COMPANY_DELETE_ADDRESS.SUCCESS:
      return { ...state }
    case constants.UPDATE_COMPANY_PRIMARY_ADDRESS.SUCCESS:
      return { ...state }
  }
})



// WEBPACK FOOTER //
// ./src/redux/modules/addressActions.js